<!--三元组-->
<template>
  <div class="triplet">
    <div class="title">
      三元组
    </div>
    <el-form :inline="true" class="search-form">
      <el-form-item label="订单号">
        <el-input v-model="searchForm.orderNo" placeholder="请输入订单号" clearable>
        </el-input>
      </el-form-item>
      <el-form-item label="产品类型" style="width: 360px;">
        <a-cascader
          v-model="categoryValue"
          :options="categoryList"
          placeholder="请选择产品类型"
          clearable
          @change="handleCategory">
        </a-cascader>
      </el-form-item>
      <el-form-item label="产品名称" style="width: 230px;">
        <el-input v-model="searchForm.productName" placeholder="请输入产品名称" style="width: 160px;" clearable>
        </el-input>
      </el-form-item>
      <el-form-item label="产品ID" style="width: 200px;">
        <el-input v-model="searchForm.productId" placeholder="请输入产品ID" style="width: 130px;" clearable>
        </el-input>
      </el-form-item>
      <el-form-item class="date">
        <!-- <el-date-picker
          v-model="dateValue"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          class="date-picker"
          clearable
          :style="{ width: '330px' }"
          :default-time="['00:00:00', '23:59:59']"
          @blur="isRestart = true">
        </el-date-picker> -->
        <el-date-picker
          v-model="dateValue"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          class="date-picker"
          clearable
          :style="{ width: '330px' }"
          :default-time="['00:00:00', '23:59:59']"
          @blur="isRestart = true">
        </el-date-picker>
      </el-form-item>
      <el-button class="btn" type="primary" size="14" @click="queryList('search')">查询</el-button>
    </el-form>
    <div class="header">
      <div class="num-title">总数量：{{ totalAmount }}，已使用：{{ usageAmount }}</div>
      <el-button type="primary" class="button-container" size="14" @click="handleAddOrder">新增订单</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width: 100%"
      size="medium"
      :header-cell-style="{ background: '#F5F6F7' }"
    >
      <el-table-column label="订单号">
        <template slot-scope="scope">
          {{ scope.row.orderNo || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="产品ID">
        <template slot-scope="scope">
          {{ scope.row.productId || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="产品信息">
        <template slot-scope="scope">
          {{ scope.row.productName }}({{ scope.row.productId || "-" }})
        </template>
      </el-table-column>
      <el-table-column label="订单说明">
        <template slot-scope="scope">
          {{ scope.row.orderDescription || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="三元组数量" width="140px">
        <template slot-scope="scope">
          {{ scope.row.totalAmount || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="已使用数量" width="140px">
        <template slot-scope="scope">
          {{ scope.row.usageAmount || "-" }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120px">
        <template slot-scope="scope">
          <el-button type="text" size="operate" @click="jumpDetails(scope.row)">详情</el-button>
          <el-button
            type="text"
            size="operate"
            :disabled="scope.row.usageAmount !== '0'"
            @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="currentPage"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-dialog
      title="新增订单"
      :visible.sync="dialogVisible"
      width="596px"
      :before-close="handleClose"
      custom-class="white-list-dialog">
      <el-form
        ref="form"
        :model="addFormData"
        :rules="rules"
        width="596px"
        label-width="95px"
        label-position="right">
        <el-form-item label="订单号" prop="orderNo">
          <template #label>
            <span>订单号</span>&nbsp;
            <el-tooltip content="订单号不能包括下列字符（\/:*?&quot;<>|空格）" placement="top">
              <i class="iconfont icon-wenhao"></i>
            </el-tooltip>
          </template>
          <el-input v-model="addFormData.orderNo" placeholder="请输入订单号" maxlength="250" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品PID" prop="productId">
          <el-input v-model="addFormData.productId" placeholder="请输入产品PID" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单说明" prop="orderDescription">
          <el-input
            v-model="addFormData.orderDescription"
            placeholder="请输入订单说明，最多100个字符"
            type="textarea"
            maxlength="100"
            show-word-limit
            :rows="6"
            clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="14" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="14" @click="onsubmit">确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { deviceCategories } from '@/api/product/create-product'
import { getList, add, statistics, deleteTriplets } from '@/api/device-identity-auth/triplet'
// 按需引入 Cascader 组件
import { Cascader } from 'ant-design-vue'
export default {
  name: 'triplet',
  components: {
    'a-cascader': Cascader
  },
  data() {
    return {
      tableData: [], // 订单列表数据
      totalAmount: '', // 三元组总数
      usageAmount: '', // 三元组已使用数
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 0, // 列表数据总条数
      loading: true,
      orderNo: '', // 订单号
      categoryValue: [], // 级联筛选大品类列表
      categoryFilterValue: '', // 接口传参产品大类+小类拼接
      categoryList: [], // 品类列表
      rawData: [], // 放原始JSON数据
      addFormData: {
        orderNo: '', // 订单号
        productId: '', // 产品信息
        orderDescription: '' // 订单说明
      },
      searchForm: {
        orderNo: '', // 订单号
        productId: '', // 产品id
        productName: '' // 产品名称
      },
      dateValue: [], // 日期范围
      rules: {
        orderNo: [
          { required: true, message: '请输入订单号', trigger: 'blur' },
          { min: 1, max: 250, message: '请输入规范的订单号', trigger: 'blur' },
          { validator: this.validateOrderNo, trigger: 'blur' }
        ],
        productId: [
          { required: true, message: '请输入产品PID', trigger: 'blur' }
        ],
        orderDescription: [
          { required: true, message: '请输入订单说明', trigger: 'blur' },
          { min: 1, max: 100, message: '请输入规范的订单说明', trigger: 'blur' }
        ]
      },
      dialogVisible: false
    }
  },
  created() {
    this.queryCategory()
    this.queryList()
    this.queryStatistics()
  },
  methods: {
    // 订单号校验
    validateOrderNo(rule, value, callback) {
      const noSpaceValue = value.replace(/\s/g, '') // 去除空格
      const flag = new RegExp(/[\\/:*?"<>|]/).test(noSpaceValue)
      if (flag) {
        callback(new Error('请输入规范的订单号'))
      } else {
        callback()
      }
    },
    // 格式化日期的函数
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    /**
     * 查询订单列表
     * @param orderNo 订单号
     * @param categoryInfoId 品类id
     * @param productId 产品id
     * @param size 每页条数
     * @param current 当前页码
     */
    queryList(condition) {
      this.currentPage = condition === 'search' ? 1 : this.currentPage
      this.loading = true
      const params = {
        ...this.searchForm,
        startTime: this.dateValue && this.dateValue.length ? this.formatDate(this.dateValue[0]) : '',
        endTime: this.dateValue && this.dateValue.length ? this.formatDate(this.dateValue[1]) : '',
        categoryInfoId: this.categoryFilterValue,
        size: this.pageSize,
        current: this.currentPage
      }
      getList(params).then(res => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.loading = false
      })
    },
    /**
     * 三元组数量统计
     */
    queryStatistics() {
      statistics().then(res => {
        this.totalAmount = res.data.data.totalAmount
        this.usageAmount = res.data.data.usageAmount
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 新增订单
    handleAddOrder() {
      this.dialogVisible = true
    },
    // 跳转详情
    jumpDetails(row) {
      this.$router.push({
        path: '/device-identity-auth/triplet/details',
        query: {
          id: row.id
        }
      })
    },
    // 删除订单
    handleDelete(id) {
      const params = {
        id: id
      }
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTriplets(params).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.queryList()
          this.queryStatistics()
        }).catch(err => {
          this.$message.error(err.message)
        })
      }).catch(err => {})
    },
    // 查询产品品类
    queryCategory() {
      deviceCategories().then(res => {
        this.rawData = res.data.data.categories
        this.categoryList = this.rawData.map(std => ({
          label: std.standardCategory,
          value: std.standardCategory,
          children: std.primaryClassification.map(primary => ({
            label: primary.category,
            value: primary.category,
            children: primary.secondClassification.map(second => ({
              label: second.name,
              value: second.categoryCode
            }))
          }))
        }))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 选择品类
    handleCategory(value) {
      this.categoryFilterValue = value[value.length - 1]
    },
    // 关闭新增订单弹窗
    handleClose() {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
    },
    /**
     * 新增订单
     */
    onsubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            ...this.addFormData,
            orderNo: this.addFormData.orderNo.replace(/\s/g, '') // 去除空格
          }
          add(params).then(res => {
            this.$message({
              type: 'success',
              message: '新增成功!'
            })
            this.queryList()
            this.queryStatistics()
            this.dialogVisible = false
            this.$refs['form'].resetFields()
          }).catch(err => {
            this.$message.error(err.message)
          })
        } else {
          return false
        }
      })
    },
    // 每页条数改变时触发
    handleSizeChange(val) {
      this.pageSize = val
      this.queryList()
    },
    // 当前页变时触发
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryList()
    }
  }
}
</script>
<style lang="scss" scoped>
.triplet {
  .search-form {
    margin: 20px 0 10px 0;

    .btn {
      float: right;
    }
  }
  .title {
    font-weight: 400;
    color: #252525;
    margin-right: 56px;
    font-size: 18px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .num-title {
      background: rgba(39, 95, 232, 0.1);
      padding: 10px;
      color: #252525;
      font-size: 18px;
    }
  }
  ::v-deep .ant-cascader-picker:focus .ant-cascader-input,
  ::v-deep .ant-input:focus,
  ::v-deep .ant-input:focus {
    border-color: #275FE8;
  }
}
</style>
<style>
.ant-cascader-menu-item:hover {
  background: #F5F7FA;
}
/* 修改日期选择器弹窗底部"清空"按钮文字为"关闭" */
.el-picker-panel__footer .el-button--text:first-child {
  font-size: 0 !important;
}
.el-picker-panel__footer .el-button--text:first-child::after {
  content: '关闭';
  font-size: 12px;
}
</style>
